<template>
  <b-container class="contentcontainer">
      <b-row align-v="center" class="contentcontainer__head">
        <b-col>
          <h2>{{ $t("user.monitoringsettings.viewtitle") }}</h2>
        </b-col>
        <b-col>
          <div class="actions">
            <button v-if="!formDisabled" class="btn btn-small btn--danger" @click="cancelEditMode"><span class="icon"><font-awesome-icon :icon="['fal','times']"></font-awesome-icon></span><span class="text">Cancel</span></button>
            <button v-if="!formDisabled" class="btn btn-small btn--success" @click="updateSettings"><span class="icon"><font-awesome-icon :icon="['fal','check']"></font-awesome-icon></span><span class="text">Save</span></button>
            <button class="btn btn--link" v-else @click="enableEditMode"><span class="icon"><font-awesome-icon :icon="['fal','edit']"></font-awesome-icon></span><span class="text">Edit</span></button>
          </div>
        </b-col>
      </b-row>
      <hr/>
      <b-row>
        <b-col>
          <div class="monitoring">
            <p>{{ $t("user.monitoringsettings.intro") }}</p>

            <b-form-group :label="$t('user.monitoringsettings.label')">
              <b-input-group append="minutes">
                <b-form-input
                  :disabled="!this.editMode"
                  type="number"
                  v-model="workData.config.downtime_tolerance"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
  </b-container>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {

  name: 'SettingsMonitoring',

  computed: {
    ...mapGetters('user', {
      account: 'getAccount'
    }),

    formDisabled () {
      return !this.editMode
    }
  },

  data () {
    return {
      editMode: false,
      workData: {
        config: {
          downtime_tolerance: 3
        }
      }
    }
  },

  methods: {

    ...mapActions('user', [
      'getAccount'
    ]),

    cancelEditMode () {
      this.workData = this.account
      this.editMode = false
    },

    enableEditMode () {
      this.editMode = true
    },

    async updateSettings (e) {
      if (typeof e !== 'undefined') {
        e.preventDefault()
      }

      let data = { ...this.workData }

      // server call to update data
      await this.axios.post('/api/account', data).then(
        response => {
          this.accountData = response.data.data
          this.getAccount()
          this.editMode = false
          this.$snotify.success('Saved successfully')
        }
      ).catch(response => {
        this.editMode = false
        this.$snotify.error('Saving failed')
      })
    }
  },

  mounted () {
    this.getAccount().then(() => {
      this.workData = this.account

      if (Array.isArray(this.workData.config)) {
        this.workData.config = { autobackup: false, downtime_tolerance: 3 }
      }

      if (!this.workData.config.downtime_tolerance) {
        this.workData.config.downtime_tolerance = 3
      }
    })
  }
}
</script>
